$(() => {
    if ($('#entry-form').length > 0) {
        $('#entry-form #p').on('paste, copy', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.bubbles = false;
        })
    }
});
